import { setValue } from '../../lib/immutable_wrapper'
import {
    SET_HEADER_ANALYSE_RISQUES,
    SET_CURRENT_ANALYSE_RISQUES_RISKS,
    GET_RISK_TYPES,
    SET_SPP_COMPANIES,
    SET_RA_COMPANIES,
    SET_REDIRECT_URL,
    SET_EDITION_STATE,
    SET_ANALYSES_RISQUES,
    GET_INSTRUCTION_TYPES,
    GET_PPE_LIST,
    GET_ACCREDITATIONS_TYPES,
    SET_ICP_PARTICIPANTS,
    SET_MODULE,
    SET_PARTIAL_SPP,
    SET_NB_AR_TO_RESEND,
    SET_NB_SPP_TO_RESEND,
    SET_VALIDATION_IN_PROGRESS_FILTER,
    SET_FILTERED_ANALYSES_RISQUES,
    SET_SPP_FOUND,
    SET_NB_COMPANIES_DISPLAY
} from "./analyseRisquesConstants";

import { getDefaultHeader, getDefaultParticipants } from './analyseRisquesActions'

const initialState = {
    header: getDefaultHeader(false),
    risks: [],
    raCompanies: [],
    sppCompanies: [],
    participants: getDefaultParticipants(),
    nbCompaniesDisplay: {}
}

const analysesRisquesInitialState = {
    moduleSpp: false,
    editionState: {
        creationMode: false,
        updateMode: false,
    },
    analysesRisques: [],
    partialSpp: [],
    nbArToResend: 0,
    nbSppToResend: 0,
    onlyValidationInProgressChecked: false,
    filteredAnalysesRisques: [],
    sppFound: null
}

const ppeListState = {
    ppeList: [],
}

const accreditationsState = {
    accreditations: [],
}

const riskTypesInitialState = {
    types: [],
}

const solutionTypesInitialState = {
    types: [],
};

export function analyseRisques(state = initialState, action) {
    switch (action.type) {
        case SET_HEADER_ANALYSE_RISQUES:
            return setValue(state, ['header'], action.header);
        case SET_CURRENT_ANALYSE_RISQUES_RISKS:
            return setValue(state, ['risks'], action.currentRisks);
        case SET_SPP_COMPANIES:
            return setValue(state, ['sppCompanies'], action.companies);
        case SET_RA_COMPANIES:
            return setValue(state, ['raCompanies'], action.companies);
        case SET_REDIRECT_URL:
            return setValue(state, ['redirectUrl'], action.url);
        case SET_ICP_PARTICIPANTS:
            return setValue(state, ['participants'], action.participants);
        case SET_SPP_FOUND:
            return setValue(state, ['sppFound'], action.sppFound)
        case SET_NB_COMPANIES_DISPLAY:
            return setValue(state, ['nbCompaniesDisplay'], action.nbCompaniesDisplay);
        default:
            return state;
    }
}

export function analysesRisques(state = analysesRisquesInitialState, action) {
    switch (action.type) {
        case SET_MODULE:
            return setValue(state, ['moduleSpp'], action.moduleSpp);
        case SET_EDITION_STATE:
            return setValue(state, ['editionState'], action.state);
        case SET_ANALYSES_RISQUES:
            return setValue(state, ['analysesRisques'], action.analysesRisques);
        case SET_PARTIAL_SPP:
            return setValue(state, ['partialSpp'], action.partialSpp);
        case SET_NB_AR_TO_RESEND:
            return setValue(state, ['nbArToResend'], action.nbArToResend);
        case SET_NB_SPP_TO_RESEND:
            return setValue(state, ['nbSppToResend'], action.nbSppToResend);
        case SET_VALIDATION_IN_PROGRESS_FILTER:
            return setValue(state, ['onlyValidationInProgressChecked'], action.onlyValidationInProgressChecked);
        case SET_FILTERED_ANALYSES_RISQUES:
            return setValue(state, ['filteredAnalysesRisques'], action.filteredAnalysesRisques);
        default:
            return state;
    }
}

export function ppeList(state = ppeListState, action) {
    switch (action.type) {
        case GET_PPE_LIST:
            return setValue(state, ['ppeList'], action.ppeList);
        default:
            return state;
    }
}

export function accreditationTypes(state = accreditationsState, action) {
    switch (action.type) {
        case GET_ACCREDITATIONS_TYPES:
            return setValue(state, ['accreditations'], action.accreditations);
        default:
            return state;
    }
}

export function riskTypes(state = riskTypesInitialState, action) {
    switch (action.type) {
        case GET_RISK_TYPES:
            return setValue(state, ['types'], action.riskTypes);
        default:
            return state;
    }
}

export function solutionTypes(state = solutionTypesInitialState, action) {
    switch (action.type) {
        case GET_INSTRUCTION_TYPES:
            return setValue(state, ['types'], action.instructionTypes);
        default:
            return state;
    }
}
